const usuarioStore = defineStore("usuario", () => {
  const usuario = ref({
    id: null,
    nombre: "",
    apellido: "",
    email: null,
    telefono: null,
    rol_id: null,
    avatar: null,
    activo: null,
    is_password: false,
    ultimo_login: null,
    estado_id: null,
    ciudad_id: null,
    direccion: "",
    locale: "es",
    cliente: null,
  });

  const user = ref({
    id: null,
    nombre: "",
    apellido: "",
    email: null,
    telefono: null,
    rol_id: null,
    avatar: null,
    activo: null,
    is_password: false,
    ultimo_login: null,
    estado_id: null,
    ciudad_id: null,
    direccion: "",
    locale: "es",
    cliente: null,
  });

  const usuarios = ref([]);

  const draft = computed(() => clone(user.value));
  const draftUsuario = computed(() => clone(usuario.value));
  const conPermiso = computed(() => {
    return (permiso) => {
      if (usuario.value.id) {
        return usuario.value.roles[0].permissions.find(
          (permission) => permission.name == permiso
        );
      }

      return false;
    };
  });

  const getUsuarios = computed(() => {
    return (rol) => {
      return usuarios.value.filter((user) => {
        let i = user.value.roles.findIndex((role, i) => role.name == rol);
        if (i > 0) {
          return true;
        } else {
          return false;
        }
      });
    };
  });

  return {
    usuario,
    user,
    usuarios,
    draft,
    draftUsuario,
    conPermiso,
    getUsuarios,
  };
});

export default usuarioStore;
